'use strict';

angular.module('homeController', [])

.controller('HomeController', ['appInfo','localstorage', '$cookieStore', '$scope', '$rootScope', '$log', '$location', '$window', '$q', '$interval', '$timeout', 'PropertyService', 'SellerService', 'ContactService', 'AgentService','PostService'
    ,function (appInfo, localstorage,$cookieStore,$scope, $rootScope, $log, $location, $window, $q, $interval, $timeout, PropertyService, SellerService, ContactService, AgentService,PostService) {
    var ekey = $rootScope.currentUser.authdata;

    $rootScope.header.style = "collapse";
    $rootScope.header.show = true;
    $scope.page = 'home';

    angular.element('.ui.dropdown').dropdown({
                          action: 'hide'
                          });
    
    var setupListing = function(ref) {
        $rootScope.loading = true;  //Start the spinner
        $rootScope.currentListing.notifications = { mail:0, appointments:0, offers: 0,posts:0,pastInspections:0 };
        
        var lLogin = $cookieStore.get('lastLogin'); // localStorage.getItem('lastLogin') 

        SellerService.property(ekey, ref).then(function(response) {
            var result = {};

            $rootScope.currentListing.ampData =  response.ampData;
            
            result.apmMarket = [];
            angular.forEach(response.ampData.apmMarket, function (amp) {
                amp.startDate = amp.date.replace('/20','/');
                result.apmMarket.push(amp);
            });
            
            $rootScope.currentListing.ampData.apmMarket = result.apmMarket;

            //Start Mail
            result.messages = []; 
            angular.forEach(response.communication, function (com) {

                // Message in inbox
                if(typeof com.toRef.seller !== 'undefined') {

                    if(com.read == 0 ) {
                        $rootScope.currentListing.notifications.mail++;
                    }
                }
                com.startDate = moment.unix(com.date).format('DD/MM/YY');
                com.startTime = moment.unix(com.date).format('h:mm A');

                result.messages.push(com);
            });

            //Start Tasks
            result.appointments = []; 
            angular.forEach(response.appointments, function (apt) {
                AgentService.getAgent(apt.agentId).then(function(response) {
                    agent = response.result[0];
                }).then(function(response) {
                    var active = false;
                    
                    if(apt.ends > appInfo.today) {
                        active = true;
                        $rootScope.currentListing.notifications.appointments++;
                    }
                    else{
                        if(apt.type == 'buyers' || apt.type == 'open home')
                        {
                            $rootScope.currentListing.notifications.pastInspections++;
                        }
                    }
                    
                    var feedback = [];

                    switch(apt.type){
                        case 'Seller Visit':
                            apt.type = "Meeting with "+ apt.cname;
                            break;
                        case 'buyers':
                            apt.type = "Buyer Appointment";
                            break;
                        case 'open home':
                            apt.type = "Open Home";
                            break;
                        case 'market review':
                            apt.type = "Meeting with "+ apt.cname;
                            break;
                    }

                    angular.forEach(apt.feedback, function(fb) {
                        //Divide rating by 2 to display on five star directive
                        fb.rate = parseInt(fb.rank) / 2;
                        //If no feedback set up strike through
                        fb.strike = (fb.priceOpinion == 9999999)? true : false;
                    });

                    apt.label   = apt.type;
                    apt.cls     = apt.type.toLowerCase().replace(" ", "-");
                    apt.active  = active;
                    apt.str     = moment.unix(apt.starts).format('LLLL');
                    apt.day     = moment.unix(apt.starts).format('DD');
                    apt.month   = moment.unix(apt.starts).format('MMM');
                    apt.start   = moment.unix(apt.starts).format('h:mm a');
                    apt.end     = moment.unix(apt.ends).format('h:mm a');

                    apt.agent   = agent;
                    apt.count   = apt.feedback.length;
                    apt.feedback= apt.feedback;

                    result.appointments.push(apt);
                });
             });
            
            //Start Offers
            result.offers = []; 
            angular.forEach(response.offers, function (offers) {
                offers.startDate = moment.unix(offers.when).format('DD/MM/YY');
                offers.startTime = moment.unix(offers.when).format('h:mm A');

                if(offers.category == "B" ) {
                    if(offers.when > lLogin){
                        $rootScope.currentListing.notifications.offers++;    
                    }
                    result.offers.push(offers);
                }

             });    

            result.history =[];
            angular.forEach(response.history, function(hstry) {
                        hstry.startDate = moment.unix(hstry.starts).format('DD/MM/YY');
                        hstry.startTime = moment.unix(hstry.starts).format('h:mm A');
                        
                        if(hstry.name != null){
                            hstry.name = hstry.name.replace(/  +/g, ' ');

                            hstry.name = hstry.name.replace('Appointment ','');
                            //hstry.name = hstry.name.replace($rootScope.currentListing.address,'');

                            var name = hstry.name.split(" - ");

                            //Open home held by AGENT NAME at 11.30am
                            if(name[0] == 'Open Home'){
                                hstry.name = name[0]+' held by '+name[2]+' at '+ hstry.startTime;
                            }
                            else if(name[0] == 'Market Review'){ //Meeting with AGENT NAME to review the market at 11.30am
                                hstry.name = 'Meeting with '+name[2]+' to review the market at '+ hstry.startTime;
                            }
                            else if(name[0] == 'Buyer'){ //AGENT NAME meeting with buyer BUYER NAME at 11.30am
                                hstry.name = name[2]+' meeting with buyer '+name[1]+' at '+ hstry.startTime;
                            }
                            else if(name[0] == 'Seller Visit'){ //Meeting with AGENT NAME at 11.30am
                                hstry.name = 'Meeting with '+name[2]+' at '+ hstry.startTime;
                            }

                            hstry.showMore = ((hstry.ref == 'BU' || hstry.ref == 'OH') &&  hstry.starts < appInfo.today )?true:false;

                            result.history.push(hstry);
                        }
                    });

            $rootScope.currentListing.data = result;

        }).then(function(){
             var filter = {};
             filter.filterType = 'propertyRelated';

             PostService.getPosts(filter, 50,0).then(function(response) {
                $rootScope.currentListing.sellersPosts = response.length;
                //check for notifications
                angular.forEach(response, function (posts) {
                    if(posts.updated > lLogin)
                    {
                        $rootScope.currentListing.notifications.posts++;    
                    }
                });    
            });

        }).then( function (){
            //Get Listing Image

            PropertyService.getListingImage(ref).then(function(rs){
                $rootScope.currentListing.image = rs;
            });

            //setup help button position
            $('#btnHelp').css("margin-top", "-"+$window.innerHeight+"px");

            //Stop loader
            $rootScope.loading = false;
        });
    }

   

    var init = function() {
        // If this is a fresh login, find the users active properties
        if($rootScope.authload) {
            $rootScope.currentUser.listings = [];

            SellerService.listings(ekey).then(function(response) {
                if(response.length == 0){
                    $window.alert('Cannot find any active properties. Please contact your Wiseberry agent.');
                    $location.path('/login');
                }

                angular.forEach(response, function(rs) {
                   
                    var obj = { 
                        address:rs.address, 
                        streetUnit: rs.streetUnit,
                        streetRef: rs.streetRef,
                        streetName: rs.streetName,
                        streetType: rs.streetType,
                        location: rs.location,
                        postcode: rs.postcode,
                        propertyRef:rs.property, 
                        agentRef:rs.agentRef ,
                        sellerRef:rs.sellerRef, 
                        agentInfo: rs.agentInfo.result[0],
                        daysInMarket: rs.daysInMarket,
                        hits:rs.hits,
                        srsFeed:rs.srsFeed,
                        lastUsed:rs.lastUsed,
                        propertyOrganisation:rs.propertyOrganisation[0]
                    };
                    $rootScope.currentUser.listings.push(obj);
                });

                // Make the first listing the active one 
                $rootScope.currentListing = $rootScope.currentUser.listings[0];
                $rootScope.currentListing.notifications = { mail:0, appointments:0, offers: 0,posts:0,pastInspections:0 };

            }).finally(function(){
                $rootScope.authload = false;
                setupListing($rootScope.currentListing.propertyRef);
        });
        } else {
            // Recheck listing details and notifications
            if(typeof $rootScope.currentListing !== 'undefined')
            {
                setupListing($rootScope.currentListing.propertyRef);
            }
            else{
                $location.path('/');
            }
        }     
    };

    init();

}]);